import React from 'react';
import { FORM_WIDGET_COMPONENTS } from '../../common/form/formConstants';
import { FormContainer } from '../../common/form/FormContainer';
import FormItem from '../../common/form/FormItem';
import FormWidget from '../../common/form/FormWidget';
import { Field } from '../attributes';

type NumberAttributeEditorProps = {
    field: Field;
};
export default function NumberAttributeEditor({ field }: NumberAttributeEditorProps) {
    return (
        <FormContainer>
            <FormItem>
                <FormWidget name={field.name} label={field.label} component={FORM_WIDGET_COMPONENTS.number} />
            </FormItem>
        </FormContainer>
    );
}
